import * as React from 'react';
import {Query} from 'react-apollo';

import gql from 'graphql-tag';

import type {
    StageItemSidebar as StageItemSidebarQuery,
    StageItemSidebarVariables as StageItemSidebarQueryVariables,
} from 'nutshell-graphql-types';

import {SalesAutomationEditorSidebar} from './sales-automation-editor-sidebar';

type OwnProps = {
    title: string;
    parentId: string;
    onSave: () => any;
    children: React.ReactNode;
};

type GraphQLProps = {
    stage: StageItemSidebarQuery['stage'] | null | undefined;
};

type Props = OwnProps & GraphQLProps;

const GET_STAGE_ITEM_SIDEBAR = gql`
    query StageItemSidebar($stageId: ID!) {
        stage(id: $stageId) {
            id
            name
        }
    }
`;

function StageItemSidebarComponent(props: Props) {
    return (
        <SalesAutomationEditorSidebar
            title={props.title}
            subtitle={props.stage ? `within ${props.stage.name}` : ''}
            onSave={props.onSave}
        >
            {props.children}
        </SalesAutomationEditorSidebar>
    );
}

class StageQuery extends Query<StageItemSidebarQuery, StageItemSidebarQueryVariables> {}

export const StageItemSidebar = (props: OwnProps) => (
    <StageQuery query={GET_STAGE_ITEM_SIDEBAR} variables={{stageId: props.parentId}}>
        {({data}) => (
            <StageItemSidebarComponent {...props} stage={data ? data.stage : null}>
                {props.children}
            </StageItemSidebarComponent>
        )}
    </StageQuery>
);
